import script from "./AccordionBodyField.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionBodyField.vue?vue&type=script&setup=true&lang=js"

import "./AccordionBodyField.vue?vue&type=style&index=0&id=33a73087&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a73087"]])

export default __exports__